import { Button, Popconfirm, Select, Space, Table, message } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { CopyOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { getEquipments } from "../../api/equipment";
import { UserRoles } from "../user";
import { NoPermission } from "../../components/EntityForm/NoPermision/noPermission";
import {
  deleteEquipmentPreCheckQxn,
  getEquipmentPreCheckQxn,
} from "../../api/equipmentPreCheckQxn";
import { PrecheckQxnGenerator } from "../../components/PrecheckQxn/precheckQxn";
import { PER_PAGE } from "../../configs";

export function EquipmentPreCheckQxn({ user }) {
  const navigate = useNavigate();
  const perPage = PER_PAGE
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const dataIndex = (page - 1) * perPage;

  const [isLoading, setIsLoading] = useState(false);

  const [showCreatePrecheckQxn, setShowCreatePrecheckQxn] = useState(false);
  const [precheckQxnSet, setPrecheckQxnSet] = useState(null);
  const [precheckQxnSets, setPrecheckQxnSets] = useState([]);
  const [copyQuestions, setCopyQuestions] = useState(null);

  const [equipments, setEquipments] = useState([]);
  const [equipment, setEquipment] = useState(null);

  const handleDelete = async (ans) => {
    await deleteEquipmentPreCheckQxn(ans.id);
    fetchEquipmentPreCheckQxn({
      page: 1,
      perPage,
    });
  };

  const fetchEquipments = async ({ page, q }) => {
    try {
      const { results } = await getEquipments({
        page, perPage: perPage
        , q
      });
      setEquipments(results);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
  };

  const fetchEquipmentPreCheckQxn = async ({ page, equipmentId }) => {
    try {
      setIsLoading(true);
      const { total, results } = await getEquipmentPreCheckQxn({
        page,
        perPage,
        equipmentId,
      });
      setTotal(total);
      setPrecheckQxnSets(results);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!user || ![UserRoles.Admin, UserRoles.User].includes(user.role)) return;
    fetchEquipmentPreCheckQxn({
      page,
      perPage,
      q: searchQuery,
    });
  }, [user, page, searchQuery]);

  useEffect(() => {
    if (!equipment) return;
    setPage(1);
    fetchEquipmentPreCheckQxn({ page: 1, equipmentId: equipment.id });
  }, [equipment]);

  if (user && ![UserRoles.Admin, UserRoles.User].includes(user.role))
    return <NoPermission role={user.role} />;

  const TableCols = [
    { title: "No", dataIndex: "no", key: "no", width: 80 },
    { title: "Equipment", dataIndex: "equipmentName", key: "equipmentName" },
    {
      title: "Action",
      key: "action",
      with: 300,
      render: (text, record, index) => (
        <Space size={2}>
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this project?"
            onConfirm={() => handleDelete(precheckQxnSets[index])}
            okText="Yes"
            cancelText="No"
          >
            <Button type="text" icon={<DeleteOutlined />} danger></Button>
          </Popconfirm>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => {
              setPrecheckQxnSet(precheckQxnSets[index]);
            }}
          ></Button>

          <Button type='text' icon={<CopyOutlined />} onClick={() => {
            const { questions } = precheckQxnSets[index]
            setCopyQuestions(questions)
            setShowCreatePrecheckQxn(true)
          }} />
        </Space>
      ),
    },
  ];

  return (
    <Space direction="vertical" style={{ width: "100%" }} className="p-6">
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <PageHeader
          onBack={() => navigate(-1)}
          title="Equipments Precheck Questions"
          subTitle="Precheck question for equipments"
        />

        <Button type="primary" onClick={() => setShowCreatePrecheckQxn(true)}>
          Create Precheck Questions
        </Button>
      </Space>

      <Space>
        <Select
          value={equipment ? equipment.id : null}
          placeholder="Search Equipment"
          onSearch={(str) => fetchEquipments({ page: 1, q: str })}
          size="large"
          onChange={(eid) => {
            setEquipment(equipments.find((e) => e.id === eid));
          }}
          filterOption={false}
          options={equipments.map((e) => {
            return {
              value: e.id,
              label: e.name,
            };
          })}
          showSearch
        ></Select>
      </Space>

      <Table
        dataSource={precheckQxnSets.map((qxnSet, index) => {
          return {
            no: dataIndex + index + 1,
            equipmentName: qxnSet.equipment.name,
          };
        })}
        columns={TableCols}
        loading={isLoading}
        pagination={{
          size: "small",
          total,
          pageSize: perPage,
          current: parseInt(page),
          onChange: setPage,
          showQuickJumper: true,
          showTotal: () => `Total ${total} Precheck Question Set`,
          position: ["bottomLeft"],
        }}
      />

      {showCreatePrecheckQxn || precheckQxnSet ? (
        <PrecheckQxnGenerator
          precheckQxnEquipment={
            precheckQxnSet ? precheckQxnSet.equipment : null
          }
          initialValues={{ questions: copyQuestions }}
          onCancel={() => {
            setShowCreatePrecheckQxn(false);
            setCopyQuestions(null)
            setPrecheckQxnSet(null);
          }}
          onSubmit={() => {
            setShowCreatePrecheckQxn(false);
            setCopyQuestions(null)
            setPrecheckQxnSet(null);
            fetchEquipmentPreCheckQxn({ page: 1, perPage });
          }}
        />
      ) : null}
    </Space>
  );
}
